import { render, staticRenderFns } from "./UnitCard.vue?vue&type=template&id=040a1aae&scoped=true&"
import script from "./UnitCard.vue?vue&type=script&lang=js&"
export * from "./UnitCard.vue?vue&type=script&lang=js&"
import style0 from "./UnitCard.vue?vue&type=style&index=0&id=040a1aae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040a1aae",
  null
  
)

component.options.__file = "UnitCard.vue"
export default component.exports